import { isProd } from "@/lib/utilities/system"
import Script from "next/script"

export const ChatWidget = () => {

  if (!isProd() || !process.env.NEXT_PUBLIC_ZENDESK_KEY) {
    return false
  }

  return (
    <Script
      id="ze-snippet"
      strategy="lazyOnload"
      src={`https://static.zdassets.com/ekr/snippet.js?key=${process.env.NEXT_PUBLIC_ZENDESK_KEY}`}
    />
  )
}
